// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".marker-cluster-gps {\n  background-color: rgba(241, 90, 90, 0.3);\n}\n.marker-cluster-gps div {\n  background-color: rgba(241, 90, 90, 0.6);\n}", ""]);
// Exports
module.exports = exports;
